import CategoriesBrowserContainer from 'components/CategoriesBrowser/CategoriesBrowserContainer'
import CategoriesBrowserPresentation from 'components/CategoriesBrowser/CategoriesBrowserPresentation'
import CategoriesBrowserData from 'components/CategoriesBrowser/CategoriesBrowserData'

export default {
  Container: CategoriesBrowserContainer,
  Presentation: CategoriesBrowserPresentation,
  Data: CategoriesBrowserData,
}
